import download from './download_file'
import { createApp } from 'vue';

export const SELF_ASSESSMENT_COPYRIGHT_COOKIE_NAME = "_GNC-selfAssessments-copyrightAgreed"

if (document.getElementById('self-assessment-consent-modal')) {
    createApp({
      data() {
        return {
          SELF_ASSESSMENT_COPYRIGHT_COOKIE_NAME: "_GNC-selfAssessments-copyrightAgreed"
        };
      },
      methods: {
        openModal: function () {
          var url = event.target.href;
          var consentModal = document.getElementById('self-assessment-consent-modal');
          var downloadButton = document.getElementById('downloadButton');
          if (!this.getCookie(SELF_ASSESSMENT_COPYRIGHT_COOKIE_NAME)) {
            consentModal.style.display = 'flex';
            downloadButton.disabled = true;
            downloadButton.classList.remove('enabled');
            downloadButton.href = url;

            //disable background scrolling
            document.body.style.overflow = 'hidden';
          } else {
            download.dowloadFile(url, url.split('/').pop());
          }
        },
        getCookie: function (cookieName) {
          var cookies = document.cookie.split(';');
          for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(cookieName + '=')) {
              const value = decodeURIComponent(cookie.substring(cookieName.length + 1));
              return value === 'true' ? true : (value === 'false' ? false : value);
            }
          }

          return false; // Return false if the cookie name is not found
        }
      }
    }).mount('#assesment-content');

    createApp({
        data() {
          return {
            SELF_ASSESSMENT_COPYRIGHT_COOKIE_NAME: "_GNC-selfAssessments-copyrightAgreed"
          };
        },
        methods: {
          closeModal: function () {
            var consentModal = document.getElementById('self-assessment-consent-modal');
            consentModal.style.display = 'none';

            //enable background scrolling
            document.body.style.overflow = 'scroll';
          },
          toggleDownloadButton: function () {
            var downloadButton = document.getElementById('downloadButton');
            var agreeCheckbox = document.getElementById('agreeCheckbox');
            if (agreeCheckbox.checked) {
                this.setBooleanCookie(SELF_ASSESSMENT_COPYRIGHT_COOKIE_NAME, true);
                downloadButton.disabled = false;
                downloadButton.classList.add('enabled');
            } else {
                this.setBooleanCookie(SELF_ASSESSMENT_COPYRIGHT_COOKIE_NAME, false);
                downloadButton.disabled = true;
                downloadButton.classList.remove('enabled');
            }
          },
          downloadPressed: function () {
            var downloadButton = document.getElementById('downloadButton');
            if (!downloadButton.disabled) {
              var url = event.target.href;
              download.dowloadFile(url, url.split('/').pop());
              this.closeModal();
            }
          },
          setBooleanCookie: function (cookieName, value) {
            var cookieValue = encodeURIComponent(value ? "true" : "false");
            document.cookie = cookieName + "=" + cookieValue;
          }
        }
    }).mount('#self-assessment-consent-modal');
}
